import React, { Component } from "react";
import { v4 } from "uuid";
import { gql } from "@apollo/client";
import ListViewHeader from "../../ListView/ListViewHeader/ListViewHeader";
import FolderRoute from "../../SubHeader/SubHeader";
import FileGridView from "../../FileExplorer/FileGridView/FileGridView";
import ArchiveConfirmationModal from "../../Files/ArchiveConfirmationModal/ArchiveConfirmationModal";
import DynamicListViewRows from "../../ListView/ListViewRows/DynamicListViewRows";
import { notify } from "../../Notify/Notify";
import dateFormat from "dateformat";
import { apolloClient } from "../../../index";
import DocumentView from "../../DocumentView/DocumentView";
import MoveFileModal from "../../MoveFileModal/MoveFileModal";
import EmptyDocumentsIcon from "../../../assets/EmptyStates/empty_documents.svg";
import ColumnsIcon from "../../../assets/icons/layout-columns.svg";
import CustomizeColumnModal from "./CustomizeColumnModal/CustomizeColumnModal";
import EmptyStates from "../../EmptyStates/EmptyStates";
import { ColumnSortingState } from "../../FolderExplorer/FolderListView/FolderListView";
import ApprovalStatus from "../../ListView/ListViewRows/ApprovalStatus/ApprovalStatus";
import { optionalChaining } from "../../../helper";
import "./DocumentListView.scss";

class DocumentListView extends Component {
  state = {
    availableColumns: [
      "status",
      "addedBy",
      "modifiedOn",
      "modifiedBy",
      "sharedWith",
      "tagName",
      //  We need to remove 1 col to avoid overflow
      // "approval",
    ],
    heading: [
      "files",
      "status",
      "addedBy",
      "modifiedOn",
      "modifiedBy",
      "sharedWith",
      "tagName",
      // "approval",
    ],
    documentItems: this.props.documents,
    totalDocuments: this.props.documents.length,
    checked: {},
    selectAll: false,
    displayListView: true,
    isColumns: {
      isCheckbox: true,
      isPinned: false,
      isTitle: true,
      isStatus: true,
      isAddedBy: true,
      isVendor: true,
      isStartsOn: true,
      isEndOn: true,
      isShared: true,
      isDropDown: true,
      isPopover: true,
      isTagName: true,
    },
    tableSizeLarge: true,
    isDocumentView: true,
    selectedColumn: "A-Z",
    showArchiveModal: false,
    archiveItemId: "",
    archiveItemName: undefined,
    showDocumentDetailModal: false,
    shouldShowDocumentDetails: this.props.match.params.docId ? true : false,
    documentDetailModalInfo: {},
    showMoveFileModal: false,
    moveFilesId: null,
    filterDocumentType: null,
    searchValue: "",
    showCustomizeColumnModal: false,
    reloadColumns: true,
    columns: [],
    sortingValue: { column: "Files", status: ColumnSortingState.ASC },
    filterData: {},
    isApprovalStatusPopupOpened: false,
    approvalStatusData: [],
  };

  columnsDisplayMapping = {
    files: "Files",
    status: "Status",
    addedBy: "Added By",
    sharedWith: "Shared With",
    modifiedOn: "Modified On",
    modifiedBy: "Modified By",
    tagName: "Tag Name",
    // approval: "Approval",
  };

  unsortableColumns = [
    "Status",
    "Added By",
    "Shared With",
    "Modified By",
    // "Approval",
  ];

  componentDidMount() {
    let checkedDocument = {};
    this.state.documentItems.map(
      (rpKey) => (checkedDocument[rpKey.id] = false)
    );

    this.setState({ checked: checkedDocument });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.match.params.docId !== prevProps.match.params.docId ||
      (this.state.shouldShowDocumentDetails &&
        !this.state.showDocumentDetailModal)
    ) {
      this.documentOnClickHandler(this.props.match.params.docId, true);
    }
    if (prevProps !== this.props) {
      const newCheckedObj = {};
      const checkedItems = { ...this.state.checked };
      if (this.state.archiveItemName) {
        for (let key of Object.keys(this.state.checked)) {
          newCheckedObj[key] = checkedItems[key] ? true : false;
        }
      } else {
        for (let key of Object.keys(this.state.checked)) {
          newCheckedObj[key] = false;
        }
      }
      this.setState(
        {
          documentItems: this.props.documents,
          checked: newCheckedObj,
          selectAll:
            this.state.archiveItemName && this.state.selectAll ? true : false,
        },
        () => {
          this.setState({ totalDocuments: this.state.documentItems.length });
        }
      );
    }
  }

  totalChecked = () => {
    let selectedFolder = 0;
    Object.keys(this.state.checked).map((cKey) =>
      this.state.checked[cKey] ? (selectedFolder += 1) : null
    );
    return selectedFolder;
  };

  displayListHandler = () => {
    let updatedDisplayView = this.state.displayListView;
    updatedDisplayView = true;
    this.setState({ displayListView: updatedDisplayView });
  };

  displayGridtHandler = () => {
    let updatedDisplayView = this.state.displayListView;
    updatedDisplayView = false;
    this.setState({ displayListView: updatedDisplayView });
  };

  checkHandler = (id) => {
    let checkedItem = this.state.checked;
    checkedItem[id] = !this.state.checked[id];
    let count = 0;
    for (let value of Object.values(checkedItem)) {
      !value && count++;
    }
    this.setState({ checked: checkedItem, selectAll: count === 0 });
  };

  selectAllHandler = () => {
    let checkedDocuments = this.state.checked;

    Object.keys(checkedDocuments).map(
      (sKey) => (checkedDocuments[sKey] = this.state.selectAll ? false : true)
    );

    this.setState({
      checked: checkedDocuments,
      selectAll: !this.state.selectAll,
    });
  };
  unselectAllHandler = () => {
    let checkedFolders = this.state.checked;

    Object.keys(checkedFolders).map((sKey) => (checkedFolders[sKey] = false));

    this.setState({ checked: checkedFolders, selectAll: false });
  };

  sortColumnHandler = ({ column, status } = this.state.sortingValue) => {
    if (!this.unsortableColumns.includes(column)) {
      this.setState(
        {
          sortingValue: { column, status },
        },
        () => this.getFilteredData()
      );
    }
  };

  setArchiveModalVisibility = (show, itemName = undefined, itemId = "") => {
    this.setState({
      showArchiveModal: show,
      archiveItemName: itemName,
      archiveItemId: itemId,
    });
  };

  onColumnSelectedHandler = (newHeading) => {
    this.setState({ heading: ["files", ...newHeading] });
  };

  getTotalDays = (date) => {
    const dateDay = dateFormat(date, "dd");
    const dateMonth = dateFormat(date, "mm");
    const dateYear = dateFormat(date, "yyyy");

    let first = new Date();
    let second = new Date(
      parseInt(dateYear),
      parseInt(dateMonth) - 1,
      parseInt(dateDay)
    );

    const totalDays = Math.round((second - first) / (1000 * 60 * 60 * 24));
    return totalDays;
  };

  archiveDocument = (date) => {
    const totalCheck = this.totalChecked();
    if (totalCheck === 0) {
      const totalDays = this.getTotalDays(date);
      const variables = {
        documents: [this.state.archiveItemId],
        archivedTill: totalDays,
      };
      apolloClient
        .mutate({
          mutation: gql`
            mutation ArchiveDocument($documents: [UUID], $archivedTill: Int!) {
              archiveDocument(
                documents: $documents
                archivedTill: $archivedTill
              ) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          let newDocArr = [...this.state.documentItems];
          const subDocArr = newDocArr.filter(
            (subDoc) => subDoc.id !== this.state.archiveItemId
          );
          this.props.setDocuments(subDocArr);
          this.setState({
            showArchiveModal: false,
            showDocumentDetailModal: false,
            documentItems: subDocArr,
            totalDocuments: subDocArr.length,
            archiveItemId: "",
            archiveItemName: "",
          });
          const detail = "Success";
          const title = `${this.state.archiveItemName} archived successfully!`;
          const type = "success";
          notify(detail, title, type);
        })
        .catch((e) => {
          const detail = "Error";
          const title = e.message;
          const type = "error";
          notify(detail, title, type);
        });
    } else {
      if (this.state.archiveItemId.length > 0) {
        const totalDays = this.getTotalDays(date);
        const variables = {
          documents: [this.state.archiveItemId],
          archivedTill: totalDays,
        };
        apolloClient
          .mutate({
            mutation: gql`
              mutation ArchiveDocument(
                $documents: [UUID]
                $archivedTill: Int!
              ) {
                archiveDocument(
                  documents: $documents
                  archivedTill: $archivedTill
                ) {
                  success
                }
              }
            `,
            variables: variables,
          })
          .then((result) => {
            let newDocArr = this.state.documentItems;
            const subDocArr = newDocArr.filter(
              (subDoc) => subDoc.id !== this.state.archiveItemId
            );
            subDocArr.length > 0
              ? this.props.setDocuments(subDocArr)
              : this.props.setDocuments(subDocArr, true);

            const detail = "Success";
            const title = `${this.state.archiveItemName} archived successfully!`;
            const type = "success";
            notify(detail, title, type);

            // update checked documents
            const checkedItems = { ...this.state.checked };
            delete checkedItems[this.state.archiveItemId];
            this.setState({
              showArchiveModal: false,
              showDocumentDetailModal: false,
              documentItems: subDocArr,
              checked: checkedItems,
              archiveItemId: "",
              archiveItemName: undefined,
              totalDocuments: subDocArr.length,
            });
          })
          .catch((e) => {
            const detail = "Error";
            const title = e.message;
            const type = "error";
            notify(detail, title, type);
          });
      } else {
        const totalDays = this.getTotalDays(date);
        const checkedArr = [];
        const newCheckedObj = {};
        for (const [key, value] of Object.entries(this.state.checked)) {
          value ? checkedArr.push(key) : (newCheckedObj[key] = value);
        }
        const variables = {
          documents: checkedArr,
          archivedTill: totalDays,
        };
        apolloClient
          .mutate({
            mutation: gql`
              mutation ArchiveDocument(
                $documents: [UUID]
                $archivedTill: Int!
              ) {
                archiveDocument(
                  documents: $documents
                  archivedTill: $archivedTill
                ) {
                  success
                }
              }
            `,
            variables: variables,
          })
          .then((result) => {
            let newArr = [...this.state.documentItems];
            const newFilterArr = newArr.filter(
              (documentItem) => !checkedArr.includes(documentItem.id)
            );

            newFilterArr.length > 0
              ? this.props.setDocuments(newFilterArr)
              : this.props.setDocuments(newFilterArr, true);
            this.setState({
              showArchiveModal: false,
              selectAll: false,
              showDocumentDetailModal: false,
              documentItems: newFilterArr,
              checked: newCheckedObj,
              totalDocuments: newFilterArr.length,
            });
            const detail = "Success";
            const title = "All files have been successfully archived";
            const type = "success";
            notify(detail, title, type);
          })
          .catch((e) => {
            const detail = "Error";
            const title = e.message;
            const type = "error";
            notify(detail, title, type);
          });
      }
    }
  };

  documentOnClickHandler = (docId, viewOnly = true) => {
    const doc = this.state.documentItems.find((item) => item.id === docId);
    if (doc) {
      const isMovedFromRequest =
        doc?.status?.name?.toLowerCase() === "received";
      if (isMovedFromRequest) {
        const fileNameParam = encodeURIComponent(doc?.title ?? "");
        const fileIdParam = encodeURIComponent(doc?.id ?? "");
        this.props.history.push(
          `/files/${this.props.match.params.folderId}/${this.props.match.params.subId}/bulk-upload?fileName=${fileNameParam}&fileId=${fileIdParam}`
        );
        return;
      }
      this.setState({
        showDocumentDetailModal: true,
        documentDetailModalInfo: {
          title: doc.title,
          fileUrl: doc.fileUrl,
          documentObj: doc,
          viewOnly: viewOnly,
        },
      });
    }
  };

  handleSelectArchive = () => {
    this.setState({ showArchiveModal: true });
  };

  handleSelectShare = () => {
    const numCheck = this.totalChecked();
    this.props.setShareFolders(this.state.checked, numCheck);
  };

  setMoveFileModalVisibility = (id) => {
    this.setState({
      showMoveFileModal: true,
      moveFilesId: id,
    });
  };

  showMoveFileModal = () => {
    this.setState({
      showMoveFileModal: true,
    });
  };

  moveItems = (parentFolder, subFolder) => {
    // Update datebase
    const totalCheck = this.totalChecked();
    let variables;
    let checkedArr = [];
    let newCheckedObj = {};

    if (totalCheck === 0) {
      variables = {
        documentId: this.state.moveFilesId,
        folderId: subFolder,
        rootFolderId: parentFolder,
      };
    } else {
      for (const [key, value] of Object.entries(this.state.checked)) {
        value ? checkedArr.push(key) : (newCheckedObj[key] = value);
      }
      variables = {
        documentId: checkedArr,
        folderId: subFolder,
        rootFolderId: parentFolder,
      };
    }

    apolloClient
      .mutate({
        mutation: gql`
          mutation moveDocument(
            $documentId: [UUID]
            $folderId: UUID!
            $rootFolderId: UUID!
          ) {
            moveDocument(
              documentId: $documentId
              folderId: $folderId
              rootFolderId: $rootFolderId
            ) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.moveDocument.success) {
          let newDocArr = [...this.state.documentItems];
          let subDocArr = [...newDocArr];
          // If it's serach screen don't remove document from the list
          if (!this.props.isSearchDocuments) {
            if (totalCheck === 0) {
              subDocArr = newDocArr.filter(
                (subDoc) => subDoc.id !== this.state.moveFilesId
              );
            } else {
              subDocArr = newDocArr.filter(
                (documentItem) => !checkedArr.includes(documentItem.id)
              );
            }
          }

          subDocArr.length > 0
            ? this.props.setDocuments(subDocArr)
            : this.props.setDocuments(subDocArr, true);
          this.setState({
            showMoveFileModal: false,
            documentItems: subDocArr,
            totalDocuments: subDocArr.length,
          });
        }
        const detail = "Success";
        const title = "All files have been successfully moved";
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  handleFieldFilter = (filterdocumentItems, fieldLabel, fieldDataObject) => {
    let filteredDocument = filterdocumentItems;
    if (fieldDataObject["inputType"] === "Date") {
      if (fieldDataObject["filter"] === "Before") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(item[fieldLabel]).setHours(0, 0, 0, 0) <
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "After") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(item[fieldLabel]).setHours(0, 0, 0, 0) >
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "On") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(item[fieldLabel]).setHours(0, 0, 0, 0) ===
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "Between") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0) <=
              new Date(item[fieldLabel]).setHours(0, 0, 0, 0) &&
            new Date(fieldDataObject["fieldValue2"]).setHours(0, 0, 0, 0) >=
              new Date(item[fieldLabel]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "Is blank") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] === "-"
        );
      }
    } else if (fieldDataObject["inputType"] === "Number") {
      if (fieldDataObject["filter"] === "Is equal") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] === fieldDataObject["fieldValue1"]
        );
      } else if (fieldDataObject["filter"] === "Does not equal") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] !== fieldDataObject["fieldValue1"]
        );
      } else if (fieldDataObject["filter"] === "Is blank") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] === ""
        );
      } else if (fieldDataObject["filter"] === "Is less than") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            parseInt(item[fieldLabel]) <
            parseInt(fieldDataObject["fieldValue1"])
        );
      } else if (fieldDataObject["filter"] === "Is greater than") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            parseInt(item[fieldLabel]) >
            parseInt(fieldDataObject["fieldValue1"])
        );
      }
    } else if (
      fieldDataObject["inputType"] === "TextField" ||
      fieldDataObject["inputType"] === "TextArea"
    ) {
      filteredDocument = filteredDocument.filter(
        (item) =>
          item[fieldLabel] &&
          item[fieldLabel].search(fieldDataObject["value"]) >= 0
      );
    }
    return filteredDocument;
  };

  filterApplyHandler = (data) => {
    this.setState(
      {
        filterData: data,
      },
      () => this.getFilteredData()
    );
  };

  setSearchFilter = (value) => {
    let documentItems = [...this.props.loadDocuments];
    if (this.state.searchValue !== "") {
      documentItems = documentItems.filter((subfolder) =>
        subfolder.title.toLowerCase().includes(value.trim().toLowerCase())
      );
    }
    this.setState({
      searchValue: value,
      documentItems: documentItems,
    });
  };
  setSearchFilter = (value) => {
    this.setState(
      {
        searchValue: value,
      },
      () => this.getFilteredData()
    );
  };

  getFilteredData = () => {
    const { searchValue, sortingValue, filterData } = this.state;
    const { status, column } = sortingValue;

    let documentItems = [...this.props.loadDocuments];

    Object.entries(filterData).forEach(([key, value]) => {
      if (!Array.isArray(value)) {
        documentItems = this.handleFieldFilter(documentItems, key, value);
      } else {
        let filterDocuments = documentItems.filter((item) =>
          value.find((title) => title === item[key])
        );

        if (filterDocuments.length === 0) {
          filterDocuments = documentItems.filter((item) =>
            value.find((title) => item[key] && item[key].includes(title))
          );
        }

        documentItems = filterDocuments;
      }
    });

    if (this.state.searchValue !== "") {
      documentItems = documentItems.filter((subfolder) =>
        subfolder.title.toLowerCase().includes(searchValue.trim().toLowerCase())
      );
    }

    if (column === "Files") {
      if (status === ColumnSortingState.ASC) {
        documentItems = documentItems.sort((a, b) =>
          a.title.toLowerCase() > b.title.toLowerCase()
            ? 1
            : a.title.toLowerCase() < b.title.toLowerCase()
            ? -1
            : 0
        );
      } else {
        documentItems = documentItems.sort((a, b) =>
          a.title.toLowerCase() > b.title.toLowerCase()
            ? -1
            : a.title.toLowerCase() < b.title.toLowerCase()
            ? 1
            : 0
        );
      }
    } else if (column === "Modified On") {
      if (status === ColumnSortingState.ASC) {
        documentItems = documentItems.sort(
          (a, b) => new Date(b.modifiedTs) - new Date(a.modifiedTs)
        );
      } else {
        documentItems = documentItems.sort(
          (a, b) => new Date(a.modifiedTs) - new Date(b.modifiedTs)
        );
      }
    } else {
      let documentItemsWithoutNulls = documentItems.filter(function (element) {
        return element[column] !== undefined;
      });

      let sortByNumbers =
        documentItemsWithoutNulls.length > 0 &&
        documentItemsWithoutNulls.every(
          (a) => !isNaN(a[column]) && !isNaN(parseFloat(a[column]))
        );

      let sortByDates =
        documentItemsWithoutNulls.length > 0 &&
        documentItemsWithoutNulls.every((a) => Date.parse(a[column]));

      if (sortByNumbers) {
        if (status === ColumnSortingState.ASC) {
          documentItems = documentItems.sort((a, b) => {
            let item1 = a[column];
            let item2 = b[column];
            if (a[column] === undefined) {
              return 1;
            } else if (b[column] === undefined) {
              return -1;
            } else {
              return item1 - item2;
            }
          });
        } else {
          documentItems = documentItems.sort((a, b) => {
            let item1 = a[column];
            let item2 = b[column];
            if (a[column] === undefined) {
              return -1;
            } else if (b[column] === undefined) {
              return 1;
            } else {
              return item2 - item1;
            }
          });
        }
      } else if (sortByDates) {
        documentItems = this.filterDateColumn(documentItems, status, column);
      } else {
        if (status === ColumnSortingState.ASC) {
          documentItems = documentItems.sort((a, b) => {
            let item1 = a[column]?.toString();
            let item2 = b[column]?.toString();
            if (a[column] === undefined) {
              return 1;
            } else if (b[column] === undefined) {
              return -1;
            } else {
              return item1?.toLowerCase() > item2?.toLowerCase()
                ? 1
                : item1?.toLowerCase() < item2?.toLowerCase()
                ? -1
                : 0;
            }
          });
        } else {
          documentItems = documentItems.sort((a, b) => {
            let item1 = a[column]?.toString();
            let item2 = b[column]?.toString();
            if (a[column] === undefined) {
              return -1;
            } else if (b[column] === undefined) {
              return 1;
            } else {
              return item1?.toLowerCase() > item2?.toLowerCase()
                ? -1
                : item1?.toLowerCase() < item2?.toLowerCase()
                ? 1
                : 0;
            }
          });
        }
      }
    }

    this.setState({
      documentItems: documentItems,
      totalDocuments: documentItems.length,
    });
  };

  filterDateColumn = (documentItems, status, column) => {
    if (status === ColumnSortingState.ASC) {
      documentItems = documentItems.sort((a, b) => {
        let date1 = new Date(a[column]);
        let date2 = new Date(b[column]);
        if (a[column] === undefined) {
          return 1;
        } else if (b[column] === undefined) {
          return -1;
        } else {
          return date1 - date2;
        }
      });
    } else {
      documentItems = documentItems.sort((a, b) => {
        let date1 = new Date(a[column]);
        let date2 = new Date(b[column]);
        if (a[column] === undefined) {
          return -1;
        } else if (b[column] === undefined) {
          return 1;
        } else {
          return date2 - date1;
        }
      });
    }

    return documentItems;
  };

  // Handler for Approval status
  onOpenApprovalStatusHandler = (approvalData = []) => {
    this.setState({
      isApprovalStatusPopupOpened: true,
      approvalStatusData: Array.isArray(approvalData) ? approvalData : [],
    });
  };
  onCloseApprovalStatusHandler = () => {
    this.setState({
      isApprovalStatusPopupOpened: false,
      approvalStatusData: [],
    });
  };
  isApprovalRequired = () => {
    const { parentId = "", subs = [] } = this.props;
    const isApprovalRequired = subs.find((sub) => sub.id === parentId);
    if (!isApprovalRequired) {
      return false;
    }
    return Boolean(
      optionalChaining(isApprovalRequired, ["approvalRequired"], false)
    );
  };
  render() {
    return (
      <div>
        <ArchiveConfirmationModal
          showModal={this.state.showArchiveModal}
          numberOfFiles={this.totalChecked()}
          archiveItemName={this.state.archiveItemName}
          handleYesClick={(date) => {
            this.archiveDocument(date);
          }}
          handleNoClick={() => {
            this.setArchiveModalVisibility(false);
          }}
          isDocuments={true}
        />
        {!this.props.isSearchDocuments ? (
          <CustomizeColumnModal
            showModal={this.state.showCustomizeColumnModal}
            handleApply={this.onColumnSelectedHandler}
            handleCancel={() => {
              this.setState({
                showCustomizeColumnModal: false,
              });
            }}
            availableColumns={this.state.availableColumns}
            selectedColumns={this.state.heading}
            isDocumentArchive={false}
            columnsDisplayMapping={this.columnsDisplayMapping}
            reloadColumns={this.state.reloadColumns}
            stopReloadColumns={() => {
              this.setState({
                reloadColumns: false,
              });
            }}
            columns={this.state.columns}
            setColumns={(columns) => {
              this.setState({
                columns,
              });
            }}
            isApprovalRequired={this.isApprovalRequired()}
          />
        ) : null}

        <DocumentView
          showModal={this.state.showDocumentDetailModal}
          handleClose={(shouldReLoadData = false) => {
            this.setState({
              showDocumentDetailModal: false,
              shouldShowDocumentDetails: false,
            });
            if (shouldReLoadData) {
              this.setState({
                reloadColumns: true,
              });
              this.props.loadData();
            }
          }}
          setArchiveModalVisibility={this.setArchiveModalVisibility}
          {...this.state.documentDetailModalInfo}
          userRoleId={this.props.userRoleId}
          currentUserInfo={this.props.currentUserInfo}
          documentHandleShare={(data) => {
            this.props.setShareFolder(data.documentObj);
          }}
          showShareModal={this.props.showShareModal}
          showArchiveModal={this.state.showArchiveModal}
          fileUrl={this.state.documentDetailModalInfo.fileUrl}
          handleEdit={(id) => {
            this.setState(
              {
                showDocumentDetailModal: false,
              },
              () => {
                this.documentOnClickHandler(id, false);
              }
            );
          }}
          // {...this.props}
        />

        <MoveFileModal
          showModal={this.state.showMoveFileModal}
          handleClose={() =>
            this.setState({ showMoveFileModal: false, moveFilesId: null })
          }
          moveItems={this.moveItems}
          folderId={this.props.parentId}
          rootFolder={this.props.rootId}
        />

        <div className="row">
          <FolderRoute
            checkedItems={this.state.checked}
            checked={this.state.selectAll}
            displayGridtHandler={this.displayGridtHandler}
            displayListHandler={this.displayListHandler}
            selectAllHandler={this.selectAllHandler}
            unselectAllHandler={this.unselectAllHandler}
            totalChecked={this.totalChecked}
            displayListView={this.state.displayListView}
            isDocumentView={this.state.isDocumentView}
            selectedColumns={this.state.heading}
            sortColumnHandler={this.sortColumnHandler}
            selectedColumn={this.state.selectedColumn}
            setArchiveModalVisibility={this.setArchiveModalVisibility}
            handleShare={this.handleSelectShare}
            handleArchive={this.handleSelectArchive}
            filterApplyHandler={this.filterApplyHandler}
            {...this.props}
            showMoveFileModal={this.showMoveFileModal}
            filterDocumentType={this.state.filterDocumentType}
            documentItems={this.state.documentItems}
            searchValue={this.state.searchValue}
            setSearchValue={this.setSearchFilter}
            searchPlaceholder="&#xF002;  Search documents"
            handleSavedViewsApply={this.onColumnSelectedHandler}
            reloadColumns={this.state.reloadColumns}
            columns={this.state.columns}
            isApprovalRequired={this.isApprovalRequired()}
          />
        </div>
        <div className="row">
          {this.state.documentItems.length > 0 ? (
            <>
              <div
                className={
                  this.state.displayListView
                    ? "d-block col overflow-hidden"
                    : "d-none col"
                }
              >
                <div className="table-responsive document-list">
                  <table className="table">
                    <thead>
                      <tr className="folderlist-header table-borderless no-hover">
                        {this.state.heading.map((headKey) => {
                          if (
                            headKey === "approval" &&
                            !this.isApprovalRequired()
                          ) {
                            return null;
                          }
                          return (
                            <ListViewHeader
                              key={headKey}
                              columnName={
                                this.columnsDisplayMapping[headKey] || headKey
                              }
                              count={this.state.totalDocuments}
                              checked={this.state.selectAll}
                              selectAllHandler={this.selectAllHandler}
                              isCheckbox={this.state.isColumns.isCheckbox}
                              sortingValue={this.state.sortingValue}
                              sortColumnHandler={this.sortColumnHandler}
                            />
                          );
                        })}
                        {/* Column customization action button */}
                        {!this.props.isSearchDocuments ? (
                          <th scope="col">
                            <img
                              className="column-icon"
                              src={ColumnsIcon}
                              alt="Customize Columns"
                              width="24"
                              height="24"
                              onClick={() =>
                                this.setState({
                                  showCustomizeColumnModal: true,
                                })
                              }
                            />
                          </th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.documentItems.map((rKey) => (
                        <DynamicListViewRows
                          key={v4()}
                          item={rKey}
                          isFolder={false}
                          headings={this.state.heading}
                          checkHandler={this.checkHandler}
                          checked={this.state.checked[rKey.id]}
                          isColumns={this.state.isColumns}
                          size={this.state.tableSizeLarge}
                          setArchiveModalVisibility={
                            this.setArchiveModalVisibility
                          }
                          setStatus={() => {}}
                          onClick={this.documentOnClickHandler}
                          handleEdit={(id) => {
                            this.documentOnClickHandler(id, false);
                          }}
                          setMoveFileModalVisibility={
                            this.setMoveFileModalVisibility
                          }
                          isDocumentView={this.state.isDocumentView}
                          {...this.props}
                          sharedWithList={this.props.sharedWithList}
                          shouldShowApprovalLevel={this.isApprovalRequired()}
                          onOpenApprovalStatusHandler={
                            this.onOpenApprovalStatusHandler
                          }
                        />
                      ))}
                    </tbody>
                  </table>
                  <ApprovalStatus
                    isOpen={this.state.isApprovalStatusPopupOpened}
                    onCloseHandler={this.onCloseApprovalStatusHandler}
                    approvalLevels={this.state.approvalStatusData}
                  />
                </div>
              </div>
              <div
                className={
                  this.state.displayListView ? "d-none col" : "d-block col"
                }
              >
                <FileGridView
                  fileItems={this.state.documentItems}
                  isDocuments={true}
                  isDocumentView={this.state.isDocumentView}
                  checked={this.state.checked}
                  checkHandler={this.checkHandler}
                  isColumns={this.state.isColumns}
                  documentOnClickHandler={(id, bool) =>
                    this.documentOnClickHandler(id, bool)
                  }
                  onClick={this.documentOnClickHandler}
                  setMoveFileModalVisibility={this.setMoveFileModalVisibility}
                  setArchiveModalVisibility={this.setArchiveModalVisibility}
                  {...this.props}
                />
              </div>
            </>
          ) : (
            <div className="col is-size-h2 bold no-searched-documents">
              <EmptyStates
                imgSrc={EmptyDocumentsIcon}
                emptyStateTitle="No results found !"
                description="Please try again using different filters or search terms"
                emptyStateButtons={[]}
                {...this.props}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default DocumentListView;
